var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-width": "170px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "游戏中心地址"
    }
  }, [_c("el-tag", {
    attrs: {
      size: "medium"
    },
    model: {
      value: _vm.form.game_center_url,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "game_center_url", $$v);
      },
      expression: "form.game_center_url"
    }
  }, [_vm._v(_vm._s(_vm.form.game_center_url))])], 1), _c("el-form-item", {
    attrs: {
      label: "导航栏标题"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "首页轮播"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.banner_mode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "banner_mode", $$v);
      },
      expression: "form.banner_mode"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "网游列表"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_online_game,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_online_game", $$v);
      },
      expression: "form.is_show_online_game"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "更多游戏列表"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_online_game_ball,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_online_game_ball", $$v);
      },
      expression: "form.is_show_online_game_ball"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "更多游戏-游戏中心"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_gamecenter,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_gamecenter", $$v);
      },
      expression: "form.is_show_gamecenter"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("不显示")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "悬浮球"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_gamebar,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_gamebar", $$v);
      },
      expression: "form.is_show_gamebar"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("不显示")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "单机列表"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_mobile_game,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_mobile_game", $$v);
      },
      expression: "form.is_show_mobile_game"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "小游戏列表"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_show_game_album,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_show_game_album", $$v);
      },
      expression: "form.is_show_game_album"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏中心下载"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_game_center_download,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_game_center_download", $$v);
      },
      expression: "form.is_game_center_download"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏中心下载"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.is_game_center_download,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_game_center_download", $$v);
      },
      expression: "form.is_game_center_download"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("官方")]), _c("el-radio", {
    attrs: {
      label: -1
    }
  }, [_vm._v("不显示")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("自定义")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏中心默认选中分类"
    }
  }, [_c("el-checkbox-group", {
    model: {
      value: _vm.showGameCategory,
      callback: function callback($$v) {
        _vm.showGameCategory = $$v;
      },
      expression: "showGameCategory"
    }
  }, _vm._l(_vm.gameCategory, function (value, key) {
    return _c("el-checkbox", {
      key: key,
      attrs: {
        label: key
      }
    }, [_vm._v(_vm._s(value))]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "下载标题"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.game_center_download_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "game_center_download_title", $$v);
      },
      expression: "form.game_center_download_title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "下载描述"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.game_center_download_info,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "game_center_download_info", $$v);
      },
      expression: "form.game_center_download_info"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Logo"
    }
  }, [_c("upload-image", {
    attrs: {
      imageUrl: _vm.form.game_center_icon,
      fileSize: 512,
      maxWH: 720
    },
    model: {
      value: _vm.form.game_center_icon,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "game_center_icon", $$v);
      },
      expression: "form.game_center_icon"
    }
  }), _vm._v(" (512(k)为压缩限制)已上传文件 " + _vm._s(_vm.form.game_center_icon) + " ")], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveApp
    }
  }, [_vm._v("保存")]), _c("el-button", [_vm._v("取消")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };